import { Component, OnInit } from '@angular/core';
import { DataService, HelperService, HTTPService } from 'app/services';

import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ConfirmDismissDialogComponent } from '../confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-milage-information-dialog',
  templateUrl: './milage-information-dialog.component.html',
  styleUrls: ['./milage-information-dialog.component.scss'],
  providers: [DialogService],
})
export class MilageInformationDialogComponent implements OnInit {
  isProcessing: boolean = false;
  isLoading: boolean = false;
  isMandatoryPrompt: boolean = false;
  isInvalidVin: boolean = false;
  isInvalidMileage: boolean = false;
  isTrackMileageInAndOut: boolean = false;
  data = {
    mileage: '',
    vin: '',
  };
  defaultData = {
    mileage: '',
    vin: '',
  };
  isMileageMandatory: boolean = false;
  isVinMandatory: boolean = false;
  focus: any = {};
  errors: any = {};
  orderId: string = '';
  subHeading: string = '';
  currentLang:string = 'en';

  constructor(
    private httpService: HTTPService,
    private dataService: DataService,
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private helperService: HelperService,
    private dialogService: DialogService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const { orderId, isMandatoryPrompt, isVinRequired, isMileageRequired, subHeading = '',currentLang = 'en' } = this.dialogConfig.data;
    this.currentLang = currentLang;
    this.translate.use(this.currentLang)
    this.subHeading = subHeading;
    this.isMileageMandatory = this.dataService.isMileageMandatory;
    this.isVinMandatory = this.dataService.enableMandatoryVin;
    this.isTrackMileageInAndOut = this.dataService.isTrackMileageInAndOut;
    this.orderId = orderId;
    this.isMandatoryPrompt = isMandatoryPrompt;

    if (isVinRequired) {
      this.isInvalidVin = isVinRequired;
    }

    if (isMileageRequired) {
      this.isInvalidMileage = isMileageRequired;
    }

    this.getMileageVinInformation();
  }

  getMileageVinInformation() {
    this.isLoading = true;
    this.httpService
      .getMileageVinInformation(this.orderId)
      .then(({ VIN, mileage }: any) => {
        if (VIN) {
          this.data.vin = VIN;
        } else {
          this.focus.vin = this.isVinMandatory;
        }

        if (mileage) {
          this.data.mileage = mileage;
        } else if (!this.focus.vin) {
          this.focus.mileage = this.isMileageMandatory;
        }
        this.isLoading = false;
        this.defaultData = { ...this.data };
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleFocus(type: string) {
    this.focus[type] = true;
  }

  handleBlur(type: string) {
    this.focus[type] = false;
  }

  handleChange(type: string, value: string) {
    this.data[type] = value;
  }

  handleClose(isSuccess: boolean = false, data: any = {}) {
    this.dynamicDialogRef.close({ isSuccess, data });
  }

  handleValidate(): boolean {
    let isValid = true;

    if (this.isMileageMandatory && !this.data.mileage) {
      this.errors.mileage = `${this.isTrackMileageInAndOut ? 'Mileage in' : 'Mileage'} is mandatory *`;
      isValid = false;
    }

    if (this.isVinMandatory && !this.data.vin) {
      this.errors.vin = 'VIN is mandatory *';
      isValid = false;
    }

    return isValid;
  }

  handleSubmit(isForceUpdate: boolean = false, isUpdateAcrossSystem: boolean = true) {
    if (!this.handleValidate() || this.isProcessing || this.isLoading) return;

    this.isProcessing = true;
    const data = { isForceUpdate, isUpdateAcrossSystem, mileage: '', vin: '' };

    if (this.data.mileage !== this.defaultData.mileage) {
      data.mileage = this.data.mileage;
    }

    // if (this.data.vin !== this.defaultData.vin) {
    data.vin = this.data.vin;
    // }

    this.httpService
      .updateMileageVinInformation(this.orderId, data)
      .then(
        (data: any) => {
          if (data.invalidMileage) {
            const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
              width: '30%',
              styleClass: 'small-heading-dialog',
              showHeader: false,
              data: {
                styleClassHeading: 'font-14',
                title: 'Update the vehicle mileage across the system',
                message: `Current vehicle mileage for ${data.name || ''} is ${data.prevMileage},\
                  which is greater than the mileage entered on the RO.
                  Do you want to update this mileage across the system?`,
                button: {
                  success: { title: 'Yes' },
                  cancel: { title: 'No' },
                },
              },
            });

            const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
              this.handleSubmit(true, isSuccess);

              onClose.unsubscribe();
            });

            return;
          }

          this.handleClose(true, data);
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isProcessing = false;
      });
  }
}
